/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Catalog_Movement_ShrugInputs */

const en_us2_catalog_movement_shrug = /** @type {(inputs: Catalog_Movement_ShrugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`shrug`)
};

const pt_br2_catalog_movement_shrug = /** @type {(inputs: Catalog_Movement_ShrugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`encolhimento`)
};

const es_419_catalog_movement_shrug = /** @type {(inputs: Catalog_Movement_ShrugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`encogimientos`)
};

const pt_pt2_catalog_movement_shrug = /** @type {(inputs: Catalog_Movement_ShrugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`encolhimento`)
};

const fr_fr2_catalog_movement_shrug = /** @type {(inputs: Catalog_Movement_ShrugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`haussements d'épaules`)
};

const de_de2_catalog_movement_shrug = /** @type {(inputs: Catalog_Movement_ShrugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shrugs`)
};

const it_it2_catalog_movement_shrug = /** @type {(inputs: Catalog_Movement_ShrugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`scrollate`)
};

/**
* | output |
* | --- |
* | "shrug" |
*
* @param {Catalog_Movement_ShrugInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const catalog_movement_shrug = /** @type {((inputs?: Catalog_Movement_ShrugInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Catalog_Movement_ShrugInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_catalog_movement_shrug(inputs)
	if (locale === "es-419") return es_419_catalog_movement_shrug(inputs)
	if (locale === "pt-PT") return pt_pt2_catalog_movement_shrug(inputs)
	if (locale === "fr-FR") return fr_fr2_catalog_movement_shrug(inputs)
	if (locale === "de-DE") return de_de2_catalog_movement_shrug(inputs)
	if (locale === "it-IT") return it_it2_catalog_movement_shrug(inputs)
	return en_us2_catalog_movement_shrug(inputs)
});
export { catalog_movement_shrug as "catalog.movement.shrug" }